import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { PeriodisationProps } from "models/propTypes/invoicePropTypes";
import { PeriodisationMode } from "models/utilTypes/periodisationTypes";
import { DateRange } from "models/formTypes/util";
//#endregion
//#region components
import { Grid } from "@mui/material";
import MonthOrDateRangePicker from "../datePickers/monthOrDateRangePicker";
import usePeriodisationMinDate from "../forms/hooks/usePeriodisationMinDate";
import { Toggle } from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const Periodisation: React.FC<PeriodisationProps> = (props) => {
  const { value, setValue, hasError, fromRecurring, disableModeToggle, lockedTooltipText } = props;
  const minDate = usePeriodisationMinDate(value?.mode ?? "month");

  const setRange = (range: DateRange | undefined) => {
    setValue({ ...value, range });
  };

  const setMode = (mode: PeriodisationMode) => {
    setValue({ ...value, mode, range: undefined });
  };

  const setEnabledValue = (isEnabled: boolean) => {
    setValue({ ...value, isEnabled: isEnabled });
  };

  return (
    <Grid item container spacing={1} alignItems="center">
      <Grid item xs className={cssExports.invoiceProductPeriodisation}>
        <MonthOrDateRangePicker
          mode={value?.mode ?? "month"}
          onModeChange={setMode}
          range={value?.range}
          onRangeChange={setRange}
          error={hasError}
          minDate={minDate}
          disabled={props.disabled}
          modeToggleDisabled={disableModeToggle}
          lockedTooltipText={lockedTooltipText}
        />
      </Grid>
      {fromRecurring ? (
        <Grid item>
          <Grid container direction="row" spacing={1}>
            <Grid item className={cssExports.periodisationToggleLabel}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.PeriodisationAccounting)}
            </Grid>
            <Grid item>
              <Toggle
                name=""
                value={!!value?.isEnabled}
                setValue={setEnabledValue}
                disabled={props.disabled}
                onChange={() => {}}
                onBlur={() => {}}
                touched
                setTouched={() => {}}
                hasError={false}
              />
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default Periodisation;
